module.exports = __webpack_public_path__ + "static/media/oil-change.c4f23680.svg";